import {captureException} from '@sentry/react';

type Options = {
    path?: string;
    domain?: string;
    secure?: boolean;
    'max-age'?: number; // кол-во секунд через которое нужно удалить куку
};

const secondsInDay = 60 * 60 * 24;

// класс частично имитирующий методы localStorage для подмены в случае недоступности localStorage
export class Cookie {
    static setItem(name: string, value: string, options?: Options) {
        try {
            options = {
                path: '/',
                'max-age': secondsInDay * 7,
                ...options,
            };

            let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

            let propName: keyof Options;
            for (propName in options) {
                updatedCookie += '; ' + propName;
                const propValue = options[propName];
                if (propValue !== true) {
                    updatedCookie += '=' + propValue;
                }
            }

            document.cookie = updatedCookie;
        } catch (e) {
            captureException(e);
        }
    }

    static getItem(name: string): string | null {
        try {
            const encodedName = encodeURIComponent(name);
            for (let cookie of document.cookie.split(';')) {
                cookie = cookie.trim();
                if (cookie.startsWith(encodedName + '=')) {
                    return decodeURIComponent(cookie.substring(encodedName.length + 1));
                }
            }
            return null;
        } catch (e) {
            captureException(e);
            return null;
        }
    }

    static removeItem(name: string) {
        Cookie.setItem(name, '', {'max-age': 0});
    }
}
